import { apiService } from '@/services/api.service';

const sleep = (ms: number) => new Promise<void>((r) => setTimeout(r, ms));

/**
 * Suit la release d'une image après sa publication : la CI ouvre la PR de la branche de version,
 * puis le panel la merge (versions des mods gardées). Ce suivi n'est qu'un confort d'affichage :
 * le serveur finalise tout seul, même onglet fermé. `onProgress` reçoit chaque étape.
 *
 * @returns `ok` faux seulement sur un échec définitif ; une CI lente n'en est pas un.
 */
export async function followRelease(
  containerId: string,
  version: string,
  onProgress: (msg: string) => void,
  { tries = 40, intervalMs = 6000 }: { tries?: number; intervalMs?: number } = {},
): Promise<{ ok: boolean; msg: string }> {
  for (let i = 1; i <= tries; i++) {
    await sleep(intervalMs);
    const f = await apiService.finalizeContainer(containerId, version);
    if (f.data?.merged) return { ok: true, msg: `${version} : ${f.data.message}` };
    if (!f.data?.waiting) return { ok: false, msg: f.data?.message ?? f.error ?? 'Merge non abouti' };
    onProgress(`${version} : ${f.data.message} (${i})`);
  }
  return { ok: true, msg: `${version} : la CI est lente, le serveur terminera la fabrication de l'image tout seul.` };
}
